/*
 * PaceCerto — quiz de 6 perguntas (/pages/quiz).
 * Motor portado de src/lib/quiz.ts e tela de src/routes/quiz.tsx (Lovable), com as mesmas regras:
 * produto sem o dado de um critério não é eliminado nem pontua; quando nada casa,
 * soltamos um critério por vez (preço, volume, pisada, experiência, uso, ritmo) e avisamos.
 */
(() => {
  const RITMO_MIN = 3;
  const RITMO_MAX = 7;
  const PRECO_MIN = 200;
  const PRECO_MAX = 2200;
  const TOTAL_PERGUNTAS = 6;

  const USOS = [
    { valor: 'competicao', rotulo: 'Competição' },
    { valor: 'treino-rapido', rotulo: 'Treino rápido' },
    { valor: 'rodagem', rotulo: 'Rodagem' },
    { valor: 'longao', rotulo: 'Longão' },
    { valor: 'trilha', rotulo: 'Trilha' },
    { valor: 'estabilidade', rotulo: 'Estabilidade' },
  ];
  const VOLUMES = [
    { valor: 'ate-20', rotulo: 'Até 20 km', min: 0, max: 20 },
    { valor: '20-40', rotulo: '20–40 km', min: 20, max: 40 },
    { valor: '40-70', rotulo: '40–70 km', min: 40, max: 70 },
    { valor: '70-mais', rotulo: '70 km ou mais', min: 70, max: 200 },
  ];
  const PISADAS = [
    { valor: 'neutra', rotulo: 'Neutra' },
    { valor: 'pronada', rotulo: 'Pronada' },
    { valor: 'supinada', rotulo: 'Supinada' },
    { valor: 'nao-sei', rotulo: 'Não sei' },
  ];
  const EXPERIENCIAS = [
    { valor: 'comecei', rotulo: 'Comecei agora', niveis: ['iniciante'] },
    { valor: 'um-ano', rotulo: 'Corro há mais de 1 ano', niveis: ['intermediario', 'avancado'] },
    // "Compito" cobre Avançado e Elite — os dois existem no catálogo
    { valor: 'compito', rotulo: 'Compito', niveis: ['avancado', 'elite'] },
  ];

  const PADRAO = { p: 1, ritmo: 5, uso: '', km: '', pisada: '', exp: '', pmin: PRECO_MIN, pmax: PRECO_MAX };

  /**
   * A ordenação é lexicográfica, não uma soma de pesos: uso declarado,
   * depois aderência ao ritmo, depois preço do maior para o menor.
   */
  const SINONIMOS_USO = {
    competicao: ['competicao', 'prova', 'corrida', 'race'],
    'treino-rapido': ['treino-rapido', 'treino', 'tempo', 'velocidade', 'intervalado'],
    rodagem: ['rodagem', 'diario', 'dia-a-dia', 'daily'],
    longao: ['longao', 'longo', 'long-run', 'volume'],
    trilha: ['trilha', 'trail', 'montanha'],
    estabilidade: ['estabilidade', 'estabilidade-pronacao', 'suporte', 'stability'],
  };

  function iniciar() {
    const raiz = document.querySelector('[data-pc-quiz]');
    if (!raiz || raiz.dataset.pronto) return;
    raiz.dataset.pronto = '1';

    const PC = window.PaceCerto;
    const { escapar, formatMoeda, formatRitmo, slug } = PC;
    const conteudo = raiz.querySelector('[data-quiz-conteudo]');
    const ICONE_OK = PC.ICONE_OK;
    const SETA_ESQ = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 19-7-7 7-7M19 12H5"/></svg>';
    const SETA_DIR = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

    let catalogo = null;
    let erroCatalogo = false;

    /* ---------------------------------------------------------- respostas */

    const numero = (texto, padrao) => {
      if (texto === null || texto === '') return padrao;
      const n = Number(texto);
      return Number.isFinite(n) ? n : padrao;
    };
    const valido = (lista, texto) => (lista.some((item) => item.valor === texto) ? texto : '');

    function lerRespostas() {
      const busca = new URLSearchParams(window.location.search);
      const r = {
        p: Math.round(numero(busca.get('p'), PADRAO.p)),
        ritmo: Math.min(RITMO_MAX, Math.max(RITMO_MIN, numero(busca.get('ritmo'), PADRAO.ritmo))),
        uso: valido(USOS, busca.get('uso')),
        km: valido(VOLUMES, busca.get('km')),
        pisada: valido(PISADAS, busca.get('pisada')),
        exp: valido(EXPERIENCIAS, busca.get('exp')),
        pmin: Math.min(PRECO_MAX, Math.max(PRECO_MIN, numero(busca.get('pmin'), PADRAO.pmin))),
        pmax: Math.min(PRECO_MAX, Math.max(PRECO_MIN, numero(busca.get('pmax'), PADRAO.pmax))),
      };
      if (r.pmin > r.pmax) r.pmin = r.pmax;
      return r;
    }

    let r = lerRespostas();

    function gravarUrl() {
      const busca = new URLSearchParams(window.location.search);
      Object.keys(PADRAO).forEach((chave) => {
        if (r[chave] === PADRAO[chave]) busca.delete(chave);
        else busca.set(chave, String(r[chave]));
      });
      const texto = busca.toString();
      window.history.replaceState({}, '', `${window.location.pathname}${texto ? `?${texto}` : ''}`);
    }

    const passoAtual = () => Math.min(Math.max(r.p, 1), TOTAL_PERGUNTAS + 1);

    /* ------------------------------------------------------------ motor */

    const rotuloUso = (valor) => (USOS.find((u) => u.valor === valor) || {}).rotulo || valor;

    /**
     * Duas coisas separadas, de propósito:
     *
     *   1. ADERÊNCIA (0 a 100) — o quanto o modelo responde ao que a pessoa disse.
     *      É só técnica: ritmo, uso, nível, pisada, durabilidade e quanto da ficha
     *      está preenchida. Preço não entra aqui.
     *
     *   2. DESEMPATE COMERCIAL — a aderência é arredondada para múltiplos de
     *      PASSO_GRAU. Modelos que caem no mesmo grau são tecnicamente equivalentes,
     *      e só entre eles o de maior valor vem primeiro. Um modelo de grau menor
     *      nunca passa na frente de um de grau maior, por mais caro que seja.
     *
     * O grau aparece no card em porcentagem, então a ordem que a pessoa vê é sempre
     * decrescente: nunca aparece um número menor acima de um maior.
     */
    const PESO_FIT = { ritmo: 46, uso: 24, pisada: 12, nivel: 10, volume: 5, ficha: 3 };
    /**
     * Faixa de equivalência. Os pesos foram escolhidos para que as três coisas que a
     * pessoa declara e dá para verificar — cobrir o ritmo, ser do uso pedido e ser da
     * pisada pedida — separem graus sozinhas. Nível e completude da ficha ficam
     * abaixo do passo: são nuance, não motivo para um modelo passar na frente.
     */
    const PASSO_GRAU = 10;

    function notaRitmo(p) {
      const min = p.specs.ritmo_min;
      const max = p.specs.ritmo_max;
      if (min === null || max === null) {
        return { nota: 0.25, cobre: false, motivo: '', ressalva: 'o fabricante não publica faixa de ritmo para este modelo' };
      }
      const faixa = `${formatRitmo(min)}–${formatRitmo(max)}/km`;
      if (r.ritmo >= min && r.ritmo <= max) {
        // o fabricante diz que o modelo cobre esse ritmo: nota cheia, sem penalizar faixa larga
        return { nota: 1, cobre: true, motivo: `foi desenhado para o ritmo ${faixa}`, ressalva: '' };
      }
      const distancia = r.ritmo < min ? min - r.ritmo : r.ritmo - max;
      const segundos = Math.round(distancia * 60);
      const lado = r.ritmo < min ? 'mais rápido' : 'mais lento';
      const nota = distancia <= 0.25 ? 0.66 : distancia <= 0.5 ? 0.42 : distancia <= 1 ? 0.15 : 0;
      return { nota, cobre: false, motivo: '', ressalva: `a faixa é ${faixa}: você pediu ${segundos}s ${lado} do que o modelo cobre` };
    }

    function notaUso(p) {
      if (!r.uso) return { nota: 1, casa: true, motivo: '', ressalva: '' };
      const usos = [p.categoria, p.specs.uso].filter(Boolean).map(slug);
      if (usos.length === 0) return { nota: 0.5, casa: false, motivo: '', ressalva: 'não tem uso cadastrado' };
      const alvos = SINONIMOS_USO[r.uso] || [r.uso];
      const casa = usos.some((u) => alvos.some((a) => u.includes(a) || a.includes(u)));
      return {
        nota: casa ? 1 : 0,
        casa,
        motivo: casa ? `é um modelo de ${rotuloUso(r.uso).toLowerCase()}` : '',
        ressalva: casa ? '' : `é um modelo de ${String(p.categoria || p.specs.uso).toLowerCase()}, não de ${rotuloUso(r.uso).toLowerCase()}`,
      };
    }

    const NOTA_NIVEL = {
      comecei: { iniciante: 1, intermediario: 0.9, avancado: 0.1, elite: 0 },
      'um-ano': { intermediario: 1, avancado: 1, elite: 0.8, iniciante: 0.5 },
      compito: { avancado: 1, elite: 1, intermediario: 0.5, iniciante: 0.15 },
    };

    /** Quem começou agora vê modelos de nível iniciante/intermediário e mais em conta. */
    const perfilIniciante = () => r.exp === 'comecei';

    function notaNivel(p) {
      const tabela = NOTA_NIVEL[r.exp];
      const nivel = p.specs.nivel ? slug(p.specs.nivel) : null;
      if (!tabela || nivel === null) return { nota: 0.6, motivo: '', ressalva: '' };
      const nota = tabela[nivel] ?? 0.4;
      return {
        nota,
        motivo: nota >= 1 ? `o fabricante posiciona como ${p.specs.nivel}` : '',
        ressalva: nota <= 0.3 ? `o fabricante posiciona como ${p.specs.nivel}` : '',
      };
    }

    function notaPisada(p) {
      if (!r.pisada || r.pisada === 'nao-sei') return { nota: 0.6, motivo: '', ressalva: '' };
      const pisada = p.specs.pisada;
      if (!pisada) return { nota: 0.5, motivo: '', ressalva: 'não tem pisada cadastrada' };
      const casa = slug(pisada) === r.pisada;
      return {
        nota: casa ? 1 : 0.15,
        motivo: casa ? `é construído para pisada ${pisada.toLowerCase()}` : '',
        ressalva: casa ? '' : `é construído para pisada ${pisada.toLowerCase()}`,
      };
    }

    function notaVolume(p) {
      const faixa = VOLUMES.find((v) => v.valor === r.km);
      const vida = p.specs.vida_util_km;
      if (!faixa || vida === null) return { nota: 0.5, motivo: '', ressalva: '' };
      // volume alto valoriza durabilidade declarada, mas nunca reprova um modelo
      const exigente = faixa.min >= 40;
      const nota = vida >= 700 ? 1 : vida >= 500 ? (exigente ? 0.75 : 0.9) : exigente ? 0.45 : 0.7;
      return { nota, motivo: `tem vida útil declarada de ${vida} km`, ressalva: '' };
    }

    /** Ficha preenchida conta a favor: o contrário premiava o modelo sem dado. */
    function notaFicha(p) {
      const campos = [p.specs.ritmo_min, p.specs.peso_g, p.specs.drop, p.specs.placa, p.specs.espuma, p.specs.pisada, p.specs.nivel, p.specs.vida_util_km];
      const preenchidos = campos.filter((v) => v !== null && v !== undefined && v !== '').length;
      return { nota: preenchidos / campos.length, motivo: '', ressalva: '' };
    }

    function avaliarProduto(p) {
      const ritmo = notaRitmo(p);
      const uso = notaUso(p);
      const nivel = notaNivel(p);
      const pisada = notaPisada(p);
      const volume = notaVolume(p);
      const ficha = notaFicha(p);
      const fit =
        ritmo.nota * PESO_FIT.ritmo +
        uso.nota * PESO_FIT.uso +
        nivel.nota * PESO_FIT.nivel +
        pisada.nota * PESO_FIT.pisada +
        volume.nota * PESO_FIT.volume +
        ficha.nota * PESO_FIT.ficha;
      return {
        produto: p,
        fit,
        // o grau é o que aparece no card e o que manda na ordem: modelos no mesmo
        // grau são declarados equivalentes, e só aí o valor decide
        aderencia: Math.min(100, Math.round(fit / PASSO_GRAU) * PASSO_GRAU),
        cobreRitmo: ritmo.cobre,
        usoOk: uso.casa ? 1 : 0,
        pontos: Math.round(fit),
        motivos: [ritmo.motivo, uso.motivo, nivel.motivo, pisada.motivo, volume.motivo].filter(Boolean),
        ressalvas: [ritmo.ressalva, uso.ressalva, nivel.ressalva, pisada.ressalva].filter(Boolean),
      };
    }

    const MIN_RESULTADOS = 3;
    const MAX_RESULTADOS = 8;

    function recomendar(produtos) {
      // faixa de preço é o único corte: é o limite que a pessoa definiu
      const dentroDoPreco = produtos.filter((p) => p.preco >= r.pmin && p.preco <= r.pmax);
      const lista = dentroDoPreco.map(avaliarProduto);
      if (lista.length === 0) {
        return { recomendacoes: [], relaxados: [], afrouxouRitmo: false, afrouxouUso: false, elegiveis: 0 };
      }

      const iniciante = perfilIniciante();
      lista.sort((a, b) => {
        // 1. grau de aderência, que é o número mostrado no card
        if (b.aderencia !== a.aderencia) return b.aderencia - a.aderencia;
        // 2. dentro do mesmo grau os modelos são equivalentes: decide o valor
        if (a.produto.preco !== b.produto.preco) {
          return iniciante ? a.produto.preco - b.produto.preco : b.produto.preco - a.produto.preco;
        }
        return b.fit - a.fit || a.produto.titulo.localeCompare(b.produto.titulo, 'pt-BR');
      });

      // o ranking cresce enquanto houver modelo que cobre o ritmo e casa com o uso
      const fortes = lista.filter((item) => item.usoOk === 1 && item.cobreRitmo).length;
      const quantidade = Math.min(MAX_RESULTADOS, Math.max(MIN_RESULTADOS, fortes));
      const recomendacoes = lista.slice(0, quantidade);
      const afrouxouRitmo = recomendacoes.some((item) => !item.cobreRitmo);
      const afrouxouUso = recomendacoes.some((item) => item.usoOk === 0);
      return { recomendacoes, relaxados: [], afrouxouRitmo, afrouxouUso, elegiveis: dentroDoPreco.length };
    }

    const reais = (valor) => `R$ ${valor.toLocaleString('pt-BR')}`;

    function resumoRespostas() {
      const linhas = [{ rotulo: 'Ritmo desejado', valor: `${formatRitmo(r.ritmo)}/km` }];
      if (r.uso) linhas.push({ rotulo: 'Uso principal', valor: rotuloUso(r.uso) });
      const volume = VOLUMES.find((v) => v.valor === r.km);
      if (volume) linhas.push({ rotulo: 'Volume semanal', valor: volume.rotulo });
      const pisada = PISADAS.find((p) => p.valor === r.pisada);
      if (pisada) linhas.push({ rotulo: 'Pisada', valor: pisada.rotulo });
      const exp = EXPERIENCIAS.find((e) => e.valor === r.exp);
      if (exp) linhas.push({ rotulo: 'Experiência', valor: exp.rotulo });
      linhas.push({ rotulo: 'Faixa de preço', valor: `${reais(r.pmin)} – ${reais(r.pmax)}` });
      return linhas;
    }

    function linkCompartilhar() {
      const busca = new URLSearchParams({
        p: String(TOTAL_PERGUNTAS + 1),
        ritmo: String(r.ritmo),
        uso: r.uso,
        km: r.km,
        pisada: r.pisada,
        exp: r.exp,
        pmin: String(r.pmin),
        pmax: String(r.pmax),
      });
      return `${window.location.origin}${window.location.pathname}?${busca.toString()}`;
    }

    /* ------------------------------------------------------------- telas */

    const cabecalho = (passo) => {
      const pct = Math.min(100, (passo / TOTAL_PERGUNTAS) * 100);
      return `
        <p class="pc-eyebrow">Quiz</p>
        <h1 class="pc-quiz__titulo">Seis perguntas para encontrar o tênis certo</h1>
        <div class="pc-quiz__progresso">
          <div class="pc-quiz__progresso-texto"><span>${Math.min(passo, TOTAL_PERGUNTAS)} de ${TOTAL_PERGUNTAS}</span><span>${Math.round(pct)}%</span></div>
          <div class="pc-quiz__progresso-trilho" role="progressbar" aria-valuemin="0" aria-valuemax="${TOTAL_PERGUNTAS}" aria-valuenow="${Math.min(passo, TOTAL_PERGUNTAS)}" aria-label="Progresso do quiz"><span style="width:${pct}%"></span></div>
        </div>`;
    };

    const opcoes = (lista, campo) => `
      <div class="pc-quiz__opcoes">
        ${lista
          .map(
            (item) =>
              `<button type="button" class="pc-quiz__opcao" aria-pressed="${r[campo] === item.valor}" data-campo="${campo}" data-valor="${item.valor}">${item.rotulo}</button>`,
          )
          .join('')}
      </div>`;

    function perguntaHTML(passo) {
      switch (passo) {
        case 1:
          return `
            <h2 class="pc-quiz__pergunta" tabindex="-1">Qual ritmo você quer alcançar?</h2>
            <p class="pc-quiz__apoio">É o objetivo, não o seu ritmo de hoje. Usamos isso para cruzar com a faixa de cada modelo.</p>
            <p class="pc-quiz__valor" data-valor-ritmo>${formatRitmo(r.ritmo)} /km</p>
            <input type="range" class="pc-quiz__range" min="${RITMO_MIN}" max="${RITMO_MAX}" step="0.25" value="${r.ritmo}" aria-label="Ritmo desejado em minutos por quilômetro" aria-valuetext="${formatRitmo(r.ritmo)} por quilômetro" data-range="ritmo">
            <div class="pc-quiz__extremos" aria-hidden="true"><span>3:00</span><span>7:00</span></div>`;
        case 2:
          return `<h2 class="pc-quiz__pergunta" tabindex="-1">Qual vai ser o uso principal?</h2>${opcoes(USOS, 'uso')}`;
        case 3:
          return `<h2 class="pc-quiz__pergunta" tabindex="-1">Quanto você corre por semana?</h2>${opcoes(VOLUMES, 'km')}`;
        case 4:
          return `
            <h2 class="pc-quiz__pergunta" tabindex="-1">Como é a sua pisada?</h2>
            <p class="pc-quiz__apoio">“Não sei” não tira nenhum modelo da lista — a pisada apenas deixa de contar.</p>
            ${opcoes(PISADAS, 'pisada')}`;
        case 5:
          return `<h2 class="pc-quiz__pergunta" tabindex="-1">Há quanto tempo você corre?</h2>${opcoes(EXPERIENCIAS, 'exp')}`;
        default:
          return `
            <h2 class="pc-quiz__pergunta" tabindex="-1">Quanto você quer investir?</h2>
            <p class="pc-quiz__valor pc-quiz__valor--preco" data-valor-preco>${reais(r.pmin)} – ${reais(r.pmax)}</p>
            <label class="pc-quiz__rotulo">Preço mínimo
              <input type="range" class="pc-quiz__range" min="${PRECO_MIN}" max="${PRECO_MAX}" step="50" value="${r.pmin}" data-range="pmin">
            </label>
            <label class="pc-quiz__rotulo">Preço máximo
              <input type="range" class="pc-quiz__range" min="${PRECO_MIN}" max="${PRECO_MAX}" step="50" value="${r.pmax}" data-range="pmax">
            </label>`;
      }
    }

    function podeAvancar(passo) {
      return (
        passo === 1 ||
        passo === 6 ||
        (passo === 2 && r.uso !== '') ||
        (passo === 3 && r.km !== '') ||
        (passo === 4 && r.pisada !== '') ||
        (passo === 5 && r.exp !== '')
      );
    }

    function questaoHTML(passo) {
      return `
        ${cabecalho(passo)}
        <section class="pc-quiz__cartao" data-questao>
          ${perguntaHTML(passo)}
          <div class="pc-quiz__navegacao">
            <button type="button" class="pc-button pc-button--secundario" data-voltar ${passo === 1 ? 'disabled' : ''}>${SETA_ESQ} Voltar</button>
            <button type="button" class="pc-button" data-avancar ${podeAvancar(passo) ? '' : 'disabled'}>${passo === TOTAL_PERGUNTAS ? 'Ver recomendações' : 'Avançar'} ${SETA_DIR}</button>
          </div>
        </section>`;
    }

    function dadoFicha(valor, sufixo = '') {
      return valor === null || valor === undefined || valor === '' ? 'Não informado' : `${valor}${sufixo}`;
    }

    function fichaHTML(p) {
      const s = p.specs;
      const temRitmo = s.ritmo_min !== null && s.ritmo_max !== null;
      const dados = [
        ['Peso', s.peso_g === null ? 'Não informado' : `${s.peso_g} g · tamanho de referência não informado`],
        [
          'Stack',
          s.stack_calcanhar === null && s.stack_antepe === null
            ? 'Não informado'
            : `${dadoFicha(s.stack_calcanhar)}/${dadoFicha(s.stack_antepe)} mm`,
        ],
        ['Drop', dadoFicha(s.drop, ' mm')],
        ['Placa', dadoFicha(s.placa)],
        ['Espuma', dadoFicha(s.espuma)],
        ['Pisada', dadoFicha(s.pisada)],
        ['Vida útil', dadoFicha(s.vida_util_km, ' km')],
        ['Nível', dadoFicha(s.nivel)],
        ['Uso', dadoFicha(s.uso)],
        ['Origem', dadoFicha(s.origem)],
      ];
      return `
        <section class="pc-quiz-ficha" data-palco="escuro" aria-label="Ficha de ritmo">
          ${
            temRitmo
              ? PC.reguaHTML(s.ritmo_min, s.ritmo_max, { escura: true, estimado: p.estimado })
              : '<p class="pc-quiz-ficha__sem">Ritmo desejado não informado</p>'
          }
          <dl class="pc-quiz-ficha__dados">
            ${dados.map(([rotulo, valor]) => `<div><dt>${rotulo}</dt><dd>${escapar(valor)}</dd></div>`).join('')}
          </dl>
        </section>`;
    }

    function cardHTML(item, posicao) {
      const p = item.produto;
      return `
        <article class="pc-quiz-card">
          <a class="pc-quiz-card__foto" href="${escapar(p.url)}" tabindex="-1" aria-hidden="true">
            <span class="pc-quiz-card__posicao">${String(posicao).padStart(2, '0')}</span>
            ${p.imagem ? `<img src="${escapar(p.imagem)}" alt="" loading="lazy" width="480" height="360">` : ''}
          </a>
          <div class="pc-quiz-card__corpo">
            <p class="pc-marca">${escapar(p.marca ?? '')}</p>
            <h3 class="pc-quiz-card__titulo"><a href="${escapar(p.url)}">${escapar(p.titulo)}</a></h3>
            <p class="pc-quiz-card__preco">${formatMoeda(p.preco)}</p>
            <p class="pc-quiz-card__aderencia"><span>Aderência às suas respostas</span><strong>${item.aderencia}%</strong></p>
            ${fichaHTML(p)}
            <div>
              <p class="pc-eyebrow">Por que aparece aqui</p>
              ${
                item.motivos.length > 0
                  ? `<ul class="pc-quiz-card__motivos" role="list">${item.motivos.map((m) => `<li>${ICONE_OK}<span>${escapar(m)}</span></li>`).join('')}</ul>`
                  : '<p class="pc-quiz-card__sem-motivo">Este modelo não tem especificações cadastradas suficientes para cruzar com suas respostas.</p>'
              }
              ${
                item.ressalvas.length > 0
                  ? `<p class="pc-eyebrow pc-quiz-card__eyebrow-ressalva">O que não bate</p>
                     <ul class="pc-quiz-card__ressalvas" role="list">${item.ressalvas
                       .map((m) => `<li><span aria-hidden="true">!</span><span>${escapar(m)}</span></li>`)
                       .join('')}</ul>`
                  : ''
              }
            </div>
            <a class="pc-button pc-quiz-card__cta" href="${escapar(p.url)}">Ver ficha e escolher numeração</a>
          </div>
        </article>`;
    }

    function resultadoHTML() {
      if (!catalogo) {
        return erroCatalogo
          ? '<p class="pc-auxiliar">Não foi possível carregar o catálogo agora. Recarregue a página para tentar de novo.</p>'
          : '<p class="pc-auxiliar">Cruzando suas respostas com o catálogo…</p>';
      }
      const resultado = recomendar(catalogo);
      // o comparador aceita no máximo 3 modelos: leva os três primeiros do ranking
      const handles = resultado.recomendacoes.slice(0, 3).map((item) => item.produto.handle);
      const link = linkCompartilhar();
      const whatsapp = `https://wa.me/?text=${encodeURIComponent(`Minhas recomendações no PaceCerto: ${link}`)}`;
      return `
        <p class="pc-eyebrow">Resultado</p>
        <h1 class="pc-quiz__titulo pc-quiz__titulo--resultado" tabindex="-1">${
          resultado.recomendacoes.length > 0
            ? 'Modelos que conversam com o que você respondeu'
            : 'Nenhum modelo do catálogo cruza com essas respostas'
        }</h1>
        <ul class="pc-quiz__resumo" role="list">
          ${resumoRespostas()
            .map((linha) => `<li><span>${linha.rotulo}:</span> ${escapar(linha.valor)}</li>`)
            .join('')}
        </ul>
        ${
          resultado.afrouxouRitmo || resultado.afrouxouUso
            ? `<p class="pc-quiz__relaxado">Para fechar três modelos dentro da sua faixa de preço, incluímos ${
                resultado.afrouxouRitmo && resultado.afrouxouUso
                  ? 'opções fora da faixa de ritmo pedida e de outro uso'
                  : resultado.afrouxouRitmo
                    ? 'opções fora da faixa de ritmo pedida'
                    : 'opções de outro uso'
              }. Cada card diz exatamente o que não bate.</p>`
            : ''
        }
        <div class="pc-quiz__cards">${resultado.recomendacoes.map((item, i) => cardHTML(item, i + 1)).join('')}</div>
        <div class="pc-quiz__acoes">
          ${
            handles.length > 1
              ? `<a class="pc-button" data-comparar="${escapar(handles.join('--'))}" href="${escapar(PC.comparar.link(handles))}">Comparar os ${handles.length}${
                  resultado.recomendacoes.length > handles.length ? ' primeiros' : ''
                } lado a lado</a>`
              : ''
          }
          <a class="pc-button pc-button--secundario" href="${escapar(whatsapp)}" target="_blank" rel="noopener noreferrer">Enviar no WhatsApp</a>
          <button type="button" class="pc-button pc-button--secundario" data-refazer>Refazer o quiz</button>
        </div>
        <p class="pc-quiz__link">Link deste resultado: ${escapar(link)}</p>
        ${
          resultado.recomendacoes.length === 0
            ? `<p class="pc-quiz__linha">Você pode <a class="pc-link" href="${escapar(raiz.dataset.todos || '/collections/todos')}">ver a linha completa</a> e filtrar por conta própria.</p>`
            : ''
        }`;
    }

    function render(focar = false) {
      const passo = passoAtual();
      raiz.classList.toggle('pc-quiz--resultado', passo > TOTAL_PERGUNTAS);
      conteudo.innerHTML = passo > TOTAL_PERGUNTAS ? resultadoHTML() : questaoHTML(passo);
      if (focar) {
        const alvo = conteudo.querySelector('.pc-quiz__pergunta, .pc-quiz__titulo--resultado');
        if (alvo) alvo.focus({ preventScroll: true });
        const topo = raiz.getBoundingClientRect().top;
        if (topo < 0) raiz.scrollIntoView({ block: 'start' });
      }
    }

    function ir(destino) {
      r.p = destino;
      gravarUrl();
      render(true);
    }

    /* ---------------------------------------------------------- eventos */

    conteudo.addEventListener('click', (evento) => {
      const opcao = evento.target.closest('[data-campo]');
      if (opcao) {
        const campo = opcao.dataset.campo;
        r[campo] = opcao.dataset.valor;
        ir(passoAtual() + 1);
        return;
      }
      if (evento.target.closest('[data-avancar]')) {
        if (podeAvancar(passoAtual())) ir(passoAtual() + 1);
        return;
      }
      if (evento.target.closest('[data-voltar]')) {
        ir(Math.max(1, passoAtual() - 1));
        return;
      }
      if (evento.target.closest('[data-refazer]')) {
        ir(1);
        return;
      }
      const comparar = evento.target.closest('[data-comparar]');
      if (comparar) PC.comparar.definir(comparar.dataset.comparar.split('--'));
    });

    conteudo.addEventListener('input', (evento) => {
      const campo = evento.target.dataset.range;
      if (!campo) return;
      const valor = Number(evento.target.value);
      if (campo === 'ritmo') {
        r.ritmo = valor;
        conteudo.querySelector('[data-valor-ritmo]').textContent = `${formatRitmo(valor)} /km`;
        evento.target.setAttribute('aria-valuetext', `${formatRitmo(valor)} por quilômetro`);
      } else {
        if (campo === 'pmin') r.pmin = Math.min(valor, r.pmax);
        else r.pmax = Math.max(valor, r.pmin);
        evento.target.value = String(r[campo]);
        conteudo.querySelector('[data-valor-preco]').textContent = `${reais(r.pmin)} – ${reais(r.pmax)}`;
      }
      gravarUrl();
    });

    conteudo.addEventListener('keydown', (evento) => {
      if (evento.key !== 'Enter' || evento.target.closest('button, a')) return;
      if (evento.target.closest('[data-questao]') && podeAvancar(passoAtual())) {
        evento.preventDefault();
        ir(passoAtual() + 1);
      }
    });

    window.addEventListener('popstate', () => {
      r = lerRespostas();
      render();
    });

    render();
    PC.catalogo()
      .then((lista) => {
        catalogo = lista;
        if (passoAtual() > TOTAL_PERGUNTAS) render();
      })
      .catch(() => {
        erroCatalogo = true;
        if (passoAtual() > TOTAL_PERGUNTAS) render();
      });
  }

  if (window.PaceCerto) iniciar();
  else document.addEventListener('pc:pronto', iniciar, { once: true });
})();
